export default __webpack_public_path__ + "static/media/portada_CeciliaRamos_ENG.4f0b9b3a.jpg";